(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
  class PrivacyBar extends HTMLElement {
    constructor() {
      super();
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: this._onConsentLibraryLoaded.bind(this)
      }]);
      if (Shopify.designMode) {
        const section = this.closest('.shopify-section');
        section.addEventListener('shopify:section:select', this.show.bind(this));
        section.addEventListener('shopify:section:deselect', this.hide.bind(this));
      }
    }

    connectedCallback() {
      this.querySelector('[data-action="accept"]').addEventListener('click', this._acceptPolicy.bind(this));
      this.querySelector('[data-action="decline"]').addEventListener('click', this._declinePolicy.bind(this));
      this.querySelector('[data-action="save"]').addEventListener('click', this._savePreferences.bind(this));
      this.querySelector('[data-action="close"]').addEventListener('click', this.hide.bind(this));
    }

    show() {
      this.hidden = false;
    }

    hide() {
      this.hidden = true;
    }

    _onConsentLibraryLoaded() {
      this._prefillToggleState();

      if (window.Shopify.customerPrivacy?.shouldShowBanner?.()) {
        this.show();
        return;
      }

      const consent = window.Shopify.customerPrivacy?.currentVisitorConsent();
      const hasConsented = consent && Object.values(consent).some(v => v !== '');
      if (!hasConsented) {
        this.show();
      }
    }

    _acceptPolicy() {
      window.Shopify.customerPrivacy?.setTrackingConsent({
        analytics: true,
        marketing: true,
        preferences: true
      }, this.hide.bind(this));
    }

    _declinePolicy() {
      window.Shopify.customerPrivacy?.setTrackingConsent({
        analytics: false,
        marketing: false,
        preferences: false
      }, this.hide.bind(this));
    }

    _savePreferences() {
      const consentSettings = this._getConsentFromToggles();
      window.Shopify.customerPrivacy?.setTrackingConsent(consentSettings, this.hide.bind(this));
    }

    _prefillToggleState() {
      const consent = window.Shopify.customerPrivacy?.currentVisitorConsent?.() || {};

      this.querySelectorAll('[data-consent-category]').forEach((toggle) => {
        const category = toggle.getAttribute('data-consent-category');
        const value = consent[category];

        // Default toggles to ON when visitor consent has not been set yet.
        toggle.checked = value === '' || typeof value === 'undefined' ? true : value === 'yes';
      });
    }

    _getConsentFromToggles() {
      return Array.from(this.querySelectorAll('[data-consent-category]')).reduce((consentSettings, toggle) => {
        consentSettings[toggle.getAttribute('data-consent-category')] = toggle.checked;
        return consentSettings;
      }, {});
    }
  }

  if (!window.customElements.get('privacy-bar')) {
    window.customElements.define('privacy-bar', PrivacyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
